export default {
  'sendPayments.ach': 'Regular Payment (ACH)',
  'sendPayments.achSimple': 'Regular Payment',
  'sendPayments.international': 'International Wire (Additional fees may apply)',
  'sendPayments.internationalSimple': 'International Wire',
  'sendPayments.domestic': 'Expedited Payment (Wire fees may apply)',
  'sendPayments.domesticSimple': 'Expedited Payment',
  'sendPayments.achError': 'ACH is not available on the selected date.',
  'sendPayments.commentsMessage': 'Information sent with payment',
  'sendPayments.entity.message':
    'Your company has multiple ACH entities, choose one for your transaction.',
  'sendPayments.methodMessage': 'Available payment types affected by date',
  'sendPayments.confirmMessage':
    'You are about to <%-title %> <%-article %> <strong><%-type %></strong> of <strong><%-amount %></strong> to <strong><%-payee %></strong> from <strong><%-from %></strong> on <%-date %>.',
  'sendPayments.confirmCollectMessage':
    'You are about to <%-title %> a <strong>Collect Payment</strong> of <strong><%-amount %></strong> from <strong><%-payee %></strong> to <strong><%-from %></strong> on <%-date %>.',
  'sendPayments.confirmMessageNoFrom':
    'You are about to <%-title %> <%-article %> <strong><%-type %></strong> of <strong><%-amount %></strong> to <strong><%-payee %></strong> on <%-date %>.',
  'sendPayments.approver': 'Approved By',
  'sendPayments.approvedOn': 'Approval Date',
  'sendPayments.initiator': 'Initiated By',
  'sendPayments.initiatedOn': 'Initiated Date',
  'sendPayments.approve': 'approve',
  'sendPayments.delete': 'delete',
  'sendPayments.reject': 'reject',
  'sendPayments.updateAddress':
    'System requires the payee address to be re-entered to send this wire payment. Please go to the payee directory to modify the payee and re-enter the address.'
};
